export const monthlyViewType: any = {
  intelypro: 3
};
